<section class="container-fluid" *ngIf="development">
  <!-- <div class="row">
    <div class="col-lg-12">
      <h1>{{ development.name }}</h1>
    </div>
  </div> -->

  <div class="row header-card">
    <div class="col-lg-4 development-address">
      <div class="development-title skiptranslate">
        {{ (development !== undefined ? development.name : "") | titleCasewithAvoidWords }}
      </div>
      <div class="row">
        <div style="width: 25px">
          <img
            src="assets/img/icons/location-lg.svg"
            alt="Total Project Investment"
            width="15"
            height="22"
            class="d-none d-md-block"
          />
        </div>
        <div class="development-sub-title skiptranslate">
          {{ (development !== undefined ? development.address : "") | titleCasewithAvoidWords }}
        </div>
      </div>
    </div>
    <div class="col-lg-4 project-img outer-div">
      <div class="inner-div">
        <app-carousel
          *ngIf="development"
          [development]="development"
          [notCardImage]="true"
          [BgColor]="'#547482'"
        ></app-carousel>
      </div>
    </div>
    <div class="col-lg-4 development-map">
      <div class="map">
        <app-arcgis-map
          *ngIf="development !== undefined && development?.id"
          [zoom]="mapZoomLevel"
          [showLocationCircle]="false"
          [isProjectPage]="false"
          [inputDevelopmentId]="development !== undefined ? development.id : 0"
        ></app-arcgis-map>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 project-budget">
      <app-development-project-budget
        *ngIf="development"
        [development]="development"
      ></app-development-project-budget>
    </div>
  </div>
  <div class="row project-detail-grid-location">
    <div class="col-lg-9 project-details">
      <app-development-project-details
        *ngIf="development"
        [development]="development"
        (selectedProjectId)="selectedProjectId($event)"
      ></app-development-project-details>
    </div>
    <div
      class="col-lg-3 card selected-project"
      [ngClass]="{ 'no-selected-project': !selectedProject }"
    >
      <aside>
        <div class="bg-card bg-cardbackground" *ngIf="!selectedProject" id="no-selected-project-id">
          <div class="bg-card-text">Select a project <br />to see more details:</div>
          <div class="arrow-container"><div class="bg-card-arrow"></div></div>
          <div class="bg-card-building">
            <img
              src="assets/img/icons/project-placeholder-lg.svg"
              alt="..."
              class="d-none d-md-block building-img"
            />
          </div>
        </div>
        <div class="bg-card" *ngIf="selectedProject" id="selected-project-id">
          <app-development-project-card
            *ngIf="selectedProject"
            class="col-lg-4 col-sm-12"
            [project]="selectedProject"
            (closeModal)="closeModal()"
          ></app-development-project-card>
        </div>
      </aside>
    </div>
  </div>
  <div class="row project-detail-grid-location chart-procurement">
    <div class="col-lg-4 app-pie-char-col">
      <div class="chart-dimensions">
        <app-pie-chart *ngIf="development" [development]="development"></app-pie-chart>
        <!-- <app-charts [development]="development" [type]="chartTypeEnum.pie"></app-charts> -->
      </div>
    </div>
    <div class="col-lg-4 padding-l-0">
      <div class="chart-dimensions" *ngIf="development">
        <!-- <app-charts [development]="development" [type]="chartTypeEnum.bar"></app-charts> -->
        <app-bar-chart [development]="development"></app-bar-chart>
      </div>
    </div>
    <div class="col-lg-4 padding-l-r-0">
      <div class="chart-dimensions">
        <!-- <app-charts [development]="development" [type]="chartTypeEnum.doughnut"></app-charts> -->
        <app-doughnut-chart *ngIf="development" [development]="development"></app-doughnut-chart>
        <!-- <app-bar-chart5-year [development]="development"></app-bar-chart5-year> -->
      </div>
    </div>
    <div class="col-lg-4 padding-r-0 procurement-info print-pdf">
      <div class="chart-dimensions">
        <app-development-procurement-card></app-development-procurement-card>
      </div>
    </div>
  </div>
  <div
    class="row project-detail-grid-location chart-procurement web-display-procurement bottom-margin"
  >
    <div class="col-lg-12 padding-r-0 procurement-info">
      <div class="chart-dimensions">
        <app-development-procurement-card></app-development-procurement-card>
      </div>
    </div>
  </div>
  <!-- <div>
    <button class="btn btn-link printButton" type="button" (click)="printPDF()">
      <i class="icon icon-print icon-white"></i>
      <span class="skiptranslate">PRINT PDF</span>
    </button>
  </div> -->
  <!-- <div>
    <app-carousel [development]="development"></app-carousel>
  </div> -->
</section>
<section *ngIf="!development">
  <app-not-exist-data [activityType]="'Development'"></app-not-exist-data>
</section>
